module.exports = __webpack_public_path__ + "img/photography_thumbnail-600x450.da909554.jpg";